/*
 * Copyright (c) Nexign, JSC, 2020-2022.
 */
/**
 * Types for InquiryState component
 *
 * @author Aleksandr Perkhunov
 * @author Julia Ignatieva
 * @version 1.19.0
 * @since 1.3.0
 */

export enum EInquiryStates {
    IS_DONE = 'IS_DONE',
    WORKING = 'WORKING',
}

export interface IInquiryState {
    currentState: EInquiryStates;
    progressPercents: number | null;
}
